import { Validators } from '@angular/forms';
import { GetCountriesData } from '@shared';
import {
  CityMinLength,
  CityPatternBase,
} from '../components/addresses/address-international/address-international.constants';
import { LatinLettersTooltip } from '../components/addresses/city-select-international/city-select.constants';
import { codeUKTZEDMoldovaPattern } from '../components/parcel-places/ii-code-uktzed/ii-code-uktzed.constants';
import { DefaultCountryPhoneConfig } from '../international-invoice.constants';

const CityPatternMD = new RegExp(`^[${CityPatternBase},]+$`, 'iu');

// Moldova
export const MD: Partial<GetCountriesData> = {
  ...DefaultCountryPhoneConfig,
  CityTooltip: LatinLettersTooltip,
  RecipientPostboxAvailable: true,
  RecipientSpotSelectionAvailable: true,
  RecipientPayerAllowed: false,
  RecipientPayerAllowedOverride: true,
  CodeUKTZED: {
    validators: [
      Validators.pattern(codeUKTZEDMoldovaPattern),
      Validators.required,
    ],
    resetFieldsWhenSwitchedToThisCountry: true,
    maxLength: 10,
  },
  CodeUKTZEDDest: {
    minLength: 10,
  },
  RecipientCity: {
    validators: [
      Validators.pattern(CityPatternMD),
      Validators.minLength(CityMinLength),
    ],
  },
};
